import React, { useRef } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Tooltip from '../pages/addentities/Tooltip.js';
import { Info } from 'lucide-react';

const CalendarInput = ({ label, name, value, onChange, onBlur, readOnly = false, required = false, error = null }) => {
    const dateInputRef = useRef(null);

    const handleDateChange = (date) => {
        const formatted = date ? date.toISOString().split("T")[0] : "";
        onChange({ target: { name, value: formatted } });
    };

    const clearDate = () => {
        onChange({ target: { name, value: "" } });
    };

    const handleBlur = () => {
        if (onBlur) {
            onBlur({ target: { name, value: value || "" } });
        }
    };

    return (
        <div className="info-inner">
            {label && (
                <label className="form-label d-flex align-items-center gap-1">
                    {label}
                    {required && <span className="error-color">*</span>}
                    {name === 'release_date' &&
                    <Tooltip title="Released Date" body="The time when the SPU is released to the market">
                        <Info size={16} className="info-icon" />
                    </Tooltip>
                    }
                </label>
            )}

            <div style={{ position: "relative" }} className={error ? 'calendar-error' : ''}>
                <DatePicker
                    ref={dateInputRef}
                    selected={value ? new Date(value) : null}
                    onChange={handleDateChange}
                    dateFormat="yyyy-MM-dd"
                    id={name}
                    popperClassName="custom-calendar"
                    className="form-control common-input-all"
                    onKeyDown={(e) => e.preventDefault()}
                    onBlur={handleBlur}
                    showMonthDropdown
                    showYearDropdown
                    dropdownMode="select"
                />

                {/* Clear Button (X) */}
                {value && (
                    <span
                        onClick={clearDate}
                        style={{
                            position: "absolute",
                            right: "40px",
                            top: "50%",
                            transform: "translateY(-50%)",
                            cursor: "pointer",
                            color: "#6C757D"
                        }}
                    >
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="12"
                            height="12"
                            viewBox="0 0 12 12"
                            fill="none"
                        >
                            <path
                                d="M9 3L3 9M3 3L9 9"
                                stroke="#212529"
                                strokeWidth="1.33333"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                            />
                        </svg>
                    </span>
                )}

                {/* Calendar Icon */}
                <span
                    onClick={() => dateInputRef.current.setFocus()}
                    style={{
                        position: "absolute",
                        right: "12px",
                        top: "50%",
                        transform: "translateY(-50%)",
                        cursor: "pointer"
                    }}
                    dangerouslySetInnerHTML={{
                        __html: `
<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none">
  <path d="M6 1.5V4.5M12 1.5V4.5M2.25 7.5H15.75M3.75 3H14.25C15.078 3 15.75 3.672 15.75 4.5V15c0 .828-.672 1.5-1.5 1.5H3.75A1.5 1.5 0 0 1 2.25 15V4.5C2.25 3.672 2.922 3 3.75 3Z"
   stroke="#6C757D" stroke-width="2" stroke-linecap="round"/>
</svg>
`
                    }}
                />

                {/* Extra spacing for icons */}
                <style>{`
                    .react-datepicker-wrapper,
                    .react-datepicker__input-container {
                        width: 100%;
                    }
                    input.form-control.common-input-all {
                        padding-right: 50px !important;
                        height:40px;
                    }
                    .calendar-error input.form-control.common-input-all {
                        border-color: #dc3545 !important;
                        border: 1px solid #dc3545 !important;
                    }
                        /* POPUP container shape */
.custom-calendar .react-datepicker {
    border-radius: 18px !important;
    padding: 18px;
    border: none;
    box-shadow: 0px 2px 15px rgba(0,0,0,0.15);
}

/* Header (Month + Arrows) */
.custom-calendar .react-datepicker__header {
    // background: white !important;
    background: transparent;
    border: none !important;
    padding-top: 10px;
    font-size: 16px;
    margin-top:-25px;
}

/* Selected Day (yellow pill like screenshot) */
.custom-calendar .react-datepicker__day--selected,
.custom-calendar .react-datepicker__day--keyboard-selected {
    background-color: #FFEB00 !important;
    color: #000 !important;
    border-radius: 30px !important;
}

/* Hover */
.custom-calendar .react-datepicker__day:hover {
    background-color: #eee !important;
    border-radius: 30px !important;
}

/* Month navigation arrows */
.custom-calendar .react-datepicker__navigation-icon::before {
    border-color: #333 !important;
}

.custom-calendar select {
  border: none;
  background: transparent;
  border-radius: 6px;
  padding: 3px 6px;
  font-size: 14px;
  margin-top:-10px;
}

.custom-calendar .react-datepicker__current-month {
  display: none !important;
}
                `}</style>
            </div>
        </div>
    );
};

export default CalendarInput;
